import { useContext, useMemo } from 'react';
import { PosterContext } from '../context';

export const usePosterReactions = (posterId) => {
  const { sendReaction } = useContext(PosterContext);
  
  return {
    sendReaction: (reactionCountNumber, type) => sendReaction(posterId, reactionCountNumber, type)
  };
};
